import { X } from "lucide-react";

export default function ModalHeader({ gallery }) {

    return (

        <div className="gallery-modal-header">

            <h3>تصاویر محصول</h3>

            <button

                className="gallery-close"

                onClick={gallery.closeModal}

            >

                <X size={24} />

            </button>

        </div>

    );

}